<form class="form-popup" [formGroup]="formGroup">

  <div class="modal-header">
    <ul style="list-style-type: none;">
      <li>
        <b>Qual Task:&nbsp;&nbsp; {{newQtHistory.qualTaskId | getText:'qualTaskId':'qtDesc':qualTaskValues | async }}</b>
      </li>
      <li>
        <span style="color: orange;"><i>Note:&nbsp;&nbsp; {{newQtHistory.qualTaskId | getText:'qualTaskId':'note':qualTaskValues | async }}</i></span>
      </li>
    </ul>
  </div>

  <div class="row top10 no-gutters">
    <div class="col-xs-5 text-right" >
      <b>Completed On:&nbsp;&nbsp;</b>
    </div>
    <div class="col-xs-7">
      <mat-form-field appearance="fill">
        <mat-label></mat-label>
        <input name="Completed On" matInput [matDatepicker]="picker1"
          formControlName="completedOn" required [max]="today">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
    </div>
  </div>

  <div class="row no-gutters" *ngIf="isSelfTrained">
    <div class="col-xs-5 text-right">
      <b>Trainer:&nbsp;&nbsp;</b>
    </div>
    <div class="col-xs-7">
      {{ newQtHistory.trainedById| getText:'employeeId':'fullName':employeeValues }}
    </div>
  </div>

  <div class="row no-gutters" *ngIf="!isSelfTrained">
    <div class="col-xs-5 text-right">
      <b>Select Trainer:&nbsp;&nbsp;</b>
    </div>
    <div class="col-xs-7">
      <aims-lookup style="width:100%"
                   name="SelectTrainer"
                   id="selectTrainer"
                   [values]="filteredQttValues"
                   [idPropertyName]="'employeeId'"
                   [displayPropertyName]="'fullName'"
                   [gridText]="'Select an assigned Trainer for Qualification Task: ' + getQualTaskDescription(newQtHistory.qualTaskId)"
                   formControlName="trainedById"
                   [columnsInGrid]="trainerLookupColumns"
                   [required]="!isSelfTrained">
      </aims-lookup>
    </div>
  </div>

</form>
